"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodedError = void 0;
exports.assetToId = assetToId;
exports.assetToHumanId = assetToHumanId;
const types_1 = require("./types");
function assetToId(asset) {
    // Handle deprecated asset.activity;
    if ('activity' in asset) {
        // eslint-disable-next-line no-param-reassign
        asset = {
            type: types_1.AssetTypes.ACTIVITY,
            id: asset.activity.identifier,
            version: '1_0',
        };
    }
    if (!('type' in asset && Object.values(types_1.AssetTypes).includes(asset.type))) {
        throw new CodedError('E_ASSET_NOT_SUPPORTED', 'Asset not supported');
    }
    if (!(asset.id && typeof asset.id === 'string' && asset.id.length > 0)) {
        throw new Error('Missing asset id');
    }
    const { type, id, version = 1 } = asset;
    let normalizedVersion = String(version);
    if (type === types_1.AssetTypes.ACTIVITY) {
        normalizedVersion = `1_0`;
    }
    return `${type}.${id}~${normalizedVersion}`;
}
function assetToHumanId(asset) {
    // Handle deprecated asset.activity;
    if ('activity' in asset) {
        return asset.activity.short_name;
    }
    if (!('type' in asset && Object.values(types_1.AssetTypes).includes(asset.type))) {
        throw new CodedError('E_ASSET_NOT_SUPPORTED', 'Asset not supported');
    }
    return asset.human_id || asset.type;
}
class CodedError extends Error {
    constructor(code, message, metadata = {}) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
exports.CodedError = CodedError;
//# sourceMappingURL=utils.js.map